import Tr from 'translations/Translations';

export const VALUES = {
    PURCHASE_REQUEST: 'PURCHASE_REQUEST',
    DEMAND: 'DEMAND',
    AGREEMENT: 'AGREEMENT'
}

export const LABELS = {
    [VALUES.PURCHASE_REQUEST]: Tr('audit_task_allowed_object_type_purchase_request'),
    [VALUES.DEMAND]: Tr('audit_task_allowed_object_type_demand'),
    [VALUES.AGREEMENT]: Tr('audit_task_allowed_object_type_agreement')
}

const createItem = (e) => ({
    label: LABELS[e],
    value: e,
})

export default Object.values(VALUES).map(x => createItem(x))